import React, { Suspense, useLayoutEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import { FloatingTree } from '@floating-ui/react';

import '@ecp/common/src/assets/css/default.css';

import RecoilExternalStatePortal from '@bo-recoil/RecoilExternalStatePortal';
import LoadingSpinner from '@bo-components/common/LoadingSpinner';
import ToastProvider from '@bo-components/common/provider/ToastProvider';
import SuspenseSpinner from '@bo-components/common/SuspenseSpinner';
import InvisibleLoading from '@bo-components/common/InvisibleLoading';
import routes from './routes/Routes';
import PoRoutes from './routes/PoRoutes';
import { isPODomain } from '@bo-const/common/domain';
import './App.css';
import './ibSheet/config';
import { ThemeProvider } from 'styled-components';
import defaultTheme from '@ecp/common/src/style/theme/default';

function App() {
  useLayoutEffect(() => {
    document.title = isPODomain() ? '웰스토리몰 파트너 ADMIN' : '웰스토리몰 관리자 ADMIN';
  }, []);

  return (
    <React.StrictMode>
      <RecoilRoot>
        <ThemeProvider theme={defaultTheme}>
        <Suspense fallback={<SuspenseSpinner />}>
          <FloatingTree>
            <DndProvider backend={HTML5Backend}>
              {isPODomain() ? (
                <RouterProvider router={PoRoutes}></RouterProvider>
              ) : (
                <RouterProvider router={routes}></RouterProvider>
              )}
            </DndProvider>
          </FloatingTree>
          <InvisibleLoading />
          <LoadingSpinner />
          <ToastProvider />
        </Suspense>
        <RecoilExternalStatePortal />
        </ThemeProvider>
      </RecoilRoot>
    </React.StrictMode>
  );
}

export default App;
